import React from 'react';
import { BatteryLowIcon, CoffeeIcon, HeartCrackIcon, MoonIcon, PersonStandingIcon, RotateCcwIcon, UnplugIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Reveal } from '../Reveal';
import { costRows } from '../../data/programa';
const icons = {
  battery: BatteryLowIcon,
  coffee: CoffeeIcon,
  heart: HeartCrackIcon,
  moon: MoonIcon,
  posture: PersonStandingIcon,
  unplug: UnplugIcon,
  loop: RotateCcwIcon
} as const;
export function CostOfInaction() {
  return <section className="border-b border-line bg-navy py-[60px] lg:py-[100px]" data-id="element-63" data-mp="28247olsx9r61">
      <div className="mx-auto max-w-content px-6 text-center lg:px-10" data-id="element-64" data-mp="2331dxxie77dd">
        <SectionHeading eyebrow="La otra cuenta" title={<>
              ¿Cuánto cuesta <span className="text-gold" data-id="element-66" data-mp="1y5redp1ahfbt">no tenerlo?</span>
            </>} data-id="element-65" data-mp="2316p48402v40" />

        <Reveal delay={0.06} className="mx-auto mt-12 max-w-4xl text-left" data-id="element-67" data-mp="1t424wdtpt9pu">
          <div className="glass overflow-hidden" data-id="element-68" data-mp="1p303bqcbslkp">
            <div className="hidden grid-cols-[1.1fr_1fr] gap-6 border-b border-line px-6 py-4 sm:grid" data-id="element-69" data-mp="1p4bg2fnr13ny">
              <span className="pl-9 text-[11px] font-medium uppercase tracking-[0.1em] text-cool" data-id="element-70" data-mp="mb47ojrcri49">
                Sin Programa Atleta Corporativo
              </span>
              <span className="text-[11px] font-medium uppercase tracking-[0.1em] text-gold" data-id="element-71" data-mp="cgca3fxrsv9h">
                Costo real
              </span>
            </div>
            <ul className="divide-y divide-line" data-id="element-72" data-mp="153ycikv9htur">
              {costRows.map(row => {
              const Icon = icons[row.icon as keyof typeof icons];
              return <li key={row.problem} className="grid gap-1 px-6 py-3.5 sm:grid-cols-[1.1fr_1fr] sm:gap-6" data-id="element-73" data-mp="1a206i0u87dl0">
                    <span className="flex items-start gap-3 text-[14px] leading-[1.5] text-cool" data-id="element-74" data-mp="w534r4ckkbpc">
                      <Icon className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={1.75} aria-hidden="true" data-id="element-75" data-mp="106opfbvchua3" />
                      {row.problem}
                    </span>
                    <span className="pl-7 text-[14px] leading-[1.5] text-ice sm:pl-0" data-id="element-76" data-mp="3kwe49ow1tg2s">
                      {row.cost}
                    </span>
                  </li>;
            })}
            </ul>
          </div>
        </Reveal>

        <Reveal delay={0.08} className="mt-10" data-id="element-77" data-mp="1mfddhmq3y7yh">
          <blockquote className="mx-auto max-w-2xl text-[19px] italic leading-[1.6] text-ice sm:text-[21px]" data-id="element-78" data-mp="1hl95d053vtvt">
            “El sistema no te pide que cambies tu vida. Te pide que cambies lo
            que ya hacés, con lo que ya tenés.”
          </blockquote>
        </Reveal>
      </div>
    </section>;
}